<template>
    <div id="app" class="relative" :class="['body-' + $route.name]">
        <app-header v-if="['login'].indexOf($route.name) === -1" @menu:show="isMenuOpen = true" :shifted="isMenuOpen" />
        <app-main :shifted="isMenuOpen" />

        <Menu :shifted="isMenuOpen" @menu:hide="isMenuOpen = false" />
        <Login @menu:hide="isMenuOpen = false" />
        <Email @menu:hide="isMenuOpen = false" />
        <Alert />

        <Transition name="fade">
            <Modal v-if="ui.modal.active">
                <Transition name="fade-left" mode="out-in">
                    <LoginV2 class="transition-element" v-if="ui.modal.components.login" />
                    <SignupV2 class="transition-element" v-if="ui.modal.components.signup" />
                    <ConfirmMailV2 lass="transition-element" v-if="ui.modal.components.confirmMail" />
                    <ResetPasswordV2 class="transition-element" v-if="ui.modal.components.resetPassword" />
                </Transition>
            </Modal>
        </Transition>

        <Transition name="fade">
            <Modal v-if="ui.modalMyAccount.active">
                <Transition name="fade-left" mode="out-in">
                    <MyAdressesV2 class="transition-element" v-if="ui.modalMyAccount.components.myAdresses" />
                </Transition>
            </Modal>
        </Transition>
    </div>
</template>

<script>
import AppHeader from '@/components/AppHeader';
import AppMain from '@/components/AppMain';
import Menu from '@/components/Menu';
import Login from '@/components/Login';

import Email from '@/components/Email';
import Alert from '@/components/Alert';
import Modal from '@/components/Modal.vue';

import LoginV2 from '@/components/v2/LoginV2.vue';
import SignupV2 from '@/components/v2/SignupV2.vue';
import ResetPasswordV2 from '@/components/v2/ResetPasswordV2.vue';
import ConfirmMailV2 from '@/components/v2/ConfirmMailV2.vue';
import MyAdressesV2 from './components/v2/MyAdressesV2.vue';

export default {
    components: { Alert, Login, Email, Menu, AppMain, AppHeader, Modal, LoginV2, SignupV2, ResetPasswordV2, ConfirmMailV2, MyAdressesV2 },
    data() {
        return {
            ui: {
                modal: {
                    active: false,
                    components: {
                        login: false,
                        signup: false,
                        confirmMail: false,
                        resetPassword: false,
                    }
                },

                modalMyAccount: {
                    active: false,
                    components: {
                        myAdresses: false,
                    }
                },
            },

            isMenuOpen: false,
        };
    },
    computed: {
        getToken() {
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);

            // console.log(params.get('token'));
            return params.get('token') || '';
        },
        getEmail() {
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);

            // console.log(params.get('token'));
            return params.get('email') || '';
        }
    },
    methods: {
        showModalMyAccount() {
            const vm = this;
            vm.ui.modalMyAccount.active = true;
            vm.hideModal(); // !!! ascunde modalul de la autentificare
            //
            vm.showComponentMyAddresses();

        },
        hideModalMyAccount() {
            const vm = this;
            vm.ui.modalMyAccount.active = false;
            //
            vm.hideComponentMyAddresses();
        },
        toggleModalMyAccount() {
            const vm = this;

            if (vm.ui.modalMyAccount.active) {
                vm.hideModalMyAccount();
            } else {
                vm.showModalMyAccount();
            }
        },

        showComponentMyAddresses() {
            const vm = this;
            const sto = setTimeout(() => {
                clearTimeout(sto);
                vm.ui.modalMyAccount.components.myAdresses = true;
            }, 500);

        },
        hideComponentMyAddresses() {
            const vm = this;
            vm.ui.modalMyAccount.components.myAdresses = false;
        },

        /*
        ===================================================
        V2 LOGIN & REGISTER & RESET PASSWORD
        ===================================================
        */

        showModal() {
            this.ui.modal.active = true;
            this.trackEvent("cta_click:LoginShow",  {});
        },
        hideModal() {
            this.ui.modal.active = false;
            //this.trackEvent("cta_click:LoginHide",  {});
        },

        toggleAuthModal: function () {
            let _components = { ...this.ui.modal.components };

            Object.entries(_components).forEach((component) => {
                if (!this.ui.modal.active && !this.ui.modal.components[component[0]]) {
                    this.showModal();
                    setTimeout(() => {
                        this.ui.modal.components[component[0]] = true;
                    }, 500);
                }

                if (this.ui.modal.active && this.ui.modal.components[component[0]]) {
                    this.ui.modal.components[component[0]] = false;
                    setTimeout(() => {
                        this.hideModal();
                    }, 500);
                }
            });
        },

        closeAuthModal() {
            let _components = { ...this.ui.modal.components };

            Object.entries(_components).forEach((component) => {
                this.hideModal();
                setTimeout(() => {
                    this.ui.modal.components[component[0]] = false;
                }, 500);
            });
        },

        openSignupV2() {
            this.ui.modal.components.login = false;
            this.ui.modal.components.signup = true;
        },

        openConfirmMailV2() {
            this.ui.modal.components.login = false;
            this.ui.modal.components.confirmMail = true;
        },

        openResetPasswordV2() {
            this.ui.modal.components.login = false;
            this.ui.modal.components.signup = false;
            this.ui.modal.components.confirmMail = false;
            this.ui.modal.components.resetPassword = true;
        },
        openMyAccountV2() {
            this.closeAll();

            // this.showModal();

            setTimeout(() => {
                this.ui.modal.components.myAccount = true;
            }, 500);
        },

        closeAll() {
            this.ui.modal.components.login = false;
            this.ui.modal.components.signup = false;
            this.ui.modal.components.confirmMail = false;
            this.ui.modal.components.resetPassword = false;
            this.ui.modal.components.myAccount = false;

            this.hideModalMyAccount();
            this.hideComponentMyAddresses();
            console.log('close all');
        },

        destroyAllEmits() {
            $eventbus.$off('toggle:modal');
            $eventbus.$off('open:signup-v2');
            $eventbus.$off('open:reset-password-v2');
            $eventbus.$on('toggle-menu');
            $eventbus.$on('close-menu');
            console.log('emmits destroyed');
        },

        /*
        ===================================================
        END
        ===================================================
        */
        toggleEmail: function () {
            this.removeOpened('#email');
            $('#email').toggleClass('opened');
            this.isMenuOpen = false;
            if (this.$route.fullPath == '/search') {
                this.$router.push({
                    name: 'catalogues'
                }).catch(() => { });
            }
        },
        //
        toggleLogin: function () {
            this.removeOpened('#login');
            //
            $('#login').toggleClass('opened');
        },
        //
        openSignup: function () {
            $('#login .login-box').fadeOut();
            $('#login .signup-box').fadeIn();
        },
        //
        openResetPassword: function () {
            $('#login .login-box').fadeOut();
            $('#login .reset-password-box').fadeIn();
        },
        //
        openConfirmPassword: function () {
            $('#login .reset-password-box').fadeOut();
            $('#login .confirm-password-box').fadeIn();
        },
        //
        openAlert: function (text) {
            var self = this;
            $('#alert .text').html(text);
            $('#alert').fadeIn();
            self.timeout_alert = setTimeout(function () {
                self.closeAlert();
            }, 3000);
        },
        closeAlert: function () {
            var self = this;
            clearTimeout(self.timeout_alert);
            $('#alert').fadeOut();
        },
        //
        removeOpened: function (excepting = '') {
            $('#login .login-box').fadeIn();
            $('#login .signup-box').fadeOut();
            $('#login .reset-password-box').fadeOut();
            $('#login .confirm-password-box').fadeOut();
            //
            excepting = excepting.trim().length ? '#app *.opened:not(' + excepting + ')' : '#app *.opened';
            //
            $(excepting).removeClass('opened');
        },

        toggleMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },

        closeMenu() {
            this.isMenuOpen = false;
        },
    },
    created() {
        const vm = this;
        let token = vm.getToken.toString().trim();
        vm.$store.commit('setQueryToken', token);

        let email = vm.getEmail.toString().trim();
        vm.$store.commit('setQueryEmail', email);
    },
    mounted: function () {
        const vm = this;

        $eventbus.$on('toggle-menu', vm.toggleMenu);
        $eventbus.$on('close-menu', vm.closeMenu);
        $eventbus.$on('toggle:login', this.toggleLogin);

        $eventbus.$on('toggle:email', this.toggleEmail);
        //
        $eventbus.$on('open:signup', this.openSignup);
        $eventbus.$on('open:reset-password', this.openResetPassword);
        $eventbus.$on('open:confirm-password', this.openConfirmPassword);
        //
        $eventbus.$on('close:opened', this.removeOpened);
        //
        $eventbus.$on('open:alert', this.openAlert);
        $eventbus.$on('close:alert', this.closeAlert);

        // v2
        $eventbus.$on('show:modal', this.showModal);
        $eventbus.$on('hide:modal', this.hideModal);
        $eventbus.$on('toggle:modal', this.toggleAuthModal);
        $eventbus.$on('close:modal', this.closeAuthModal);
        $eventbus.$on('open:signup-v2', this.openSignupV2);
        $eventbus.$on('open:confirm-mail-v2', this.openConfirmMailV2);
        $eventbus.$on('open:reset-password-v2', this.openResetPasswordV2);

        //
        $eventbus.$on('open:my-account', this.showModalMyAccount);
        $eventbus.$on('close:my-account', this.hideModalMyAccount);
        $eventbus.$on('toggle:my-account', this.toggleModalMyAccount);

        $eventbus.$on('close:all', this.closeAll);

        //
        setTimeout(function () {
            if (vm.$store.state.query_token.length) {
                $eventbus.$emit('open:reset-password-v2');
                vm.ui.modal.active = true;
            } else {
                // var firstTimePDC = window.sessionStorage.getItem('firstTimePDC') || true;
                // window.sessionStorage.setItem('firstTimePDC', 'false');
                // if (firstTimePDC === true) {
                //     $eventbus.$emit('toggle:modal');
                // }
            }
        }, 1000);


        //
        let firstCall = vm.$store.state.first_call;
        let persistLogin = vm.$store.state.persist_login;

        if (firstCall && !persistLogin) {
            window.localStorage.setItem('api_token', null);
            vm.$store.commit('setApiToken', null);

            if (window.parent && window.parent.MainFrame) {
                let MainFrame = window.parent.MainFrame;
                MainFrame.EprintShop.saveItem("api_token", null);
                MainFrame.Manager.Variables.register("api_token", "0");
            }
        }
        vm.$store.commit('setFirstCall', false);

        // deschidere formular myaccount daca avem query setat
        let sto = setInterval(() => {
            const queryMyAccount = vm.$route.query.hasOwnProperty('my-account');
            if (vm.isLoggedIn && queryMyAccount) {
                clearTimeout(sto);
                vm.showModalMyAccount();
            }
        }, 100);
    },
    destroyed() {
        this.destroyAllEmits();
    },
};
</script>

<style lang="scss" scoped>
// Transitions
// Fade
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease-in-out;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

// Fade left
.fade-left-enter-active,
.fade-left-leave-active {
    transition: all 0.5s ease-in-out;
}

.fade-left-enter,
.fade-left-leave-to {
    opacity: 0;
    transform: translateX(100%);
}
</style>
